import React, { useState, useEffect } from "react";
import { Form, Input, Button, Spin, message, Card } from "antd";
import { loginUser } from "../Database/firebase";
import { Redirect } from "react-router-dom";

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
};

export default function LoginPage({ history }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [loggedIn, setLoggedIn] = useState(null);

  useEffect(() => {
    const user = localStorage.getItem("User");
    if (user) setLoggedIn(true);
    else setLoggedIn(false);
  }, []);

  const onLogin = (e) => {
    e.preventDefault();
    setLoading(true);
    loginUser(email, password)
      .then(({ email, refreshToken, uid }) => {
        if (!uid) {
          return alert("Invalid Email/Password");
        }
        localStorage.setItem(
          "User",
          JSON.stringify({ email, refreshToken, uid })
        );
        setLoggedIn(true);
      })
      .catch((err) => {
        message.warning(err.message);
        setLoading(false);
        console.log("ERR onLogin", err.message);
      });
  };

  if (loggedIn === null) return <div />;
  if (loggedIn === true) return <Redirect to={"/dashboard"} />;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <Card
        style={{
          margin: 50,
          borderRadius: 10,
          width: "25%",
          alignContent: "center",
        }}
      >
        <Form {...layout} name="basic" layout="vertical" style={{ margin: 4 }}>
          <div>
            <h1
              style={{
                textTransform: "uppercase",
                lineHeight: 0,
                fontWeight: "bold",
              }}
            >
              Welcome back
            </h1>
            <p
              style={{
                textTransform: "uppercase",
                fontSize: 12,
                fontWeight: "bold",
              }}
            >
              {" "}
              sign in to continue{" "}
            </p>
          </div>
          <Form.Item
            style={{
              textTransform: "uppercase",
              color: "#6b6b6b",
              fontWeight: "bold",
            }}
            className="inputLable"
            label="Email"
            name="email"
            rules={[
              {
                required: true,
                message: "Please input your email!",
              },
            ]}
          >
            <Input
              value={email}
              onChange={({ target }) => setEmail(target.value)}
              style={{ borderRadius: 15 }}
            />
          </Form.Item>

          <Form.Item
            style={{
              textTransform: "uppercase",
              color: "#6b6b6b",
              fontWeight: "bold",
            }}
            label="Password"
            name="password"
            rules={[
              {
                required: true,
                message: "Please input your password!",
              },
            ]}
          >
            <Input
              type="password"
              value={password}
              onChange={({ target }) => setPassword(target.value)}
              style={{ borderRadius: 15 }}
            />
          </Form.Item>

          <Form.Item>
            <Spin spinning={loading}>
              <Button
                onClick={onLogin}
                type="primary"
                htmlType="submit"
                block
                style={{
                  background: "#ff0b53",
                  borderColor: "#ff0b53",
                  borderRadius: 5,
                }}
              >
                Submit
              </Button>
            </Spin>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}
